import { Component, Input, SimpleChanges, OnInit, Output, EventEmitter } from "@angular/core";
import { TextosService } from "./textos.service";
import { Texto } from "../../Modelos/Texto";
import { TextoVM } from "./TextoVM";

@Component({
    selector: 'textos',
    templateUrl: './textos.component.html'
})
export class TextosComponent implements OnInit{
    @Input() codigoRamo;
    @Output() alternarLoader=new EventEmitter();
    textos: TextoVM[];
    textoAclaratorio: string;

    constructor(private textosService: TextosService){}

    ngOnInit(){
        this.textos=[];
        this.textoAclaratorio="";
    }

    async ngOnChanges(changes: SimpleChanges){
        if(changes.hasOwnProperty("codigoRamo")){
            this.alternarLoader.emit();
            let textosResult: Texto[];
            textosResult=await this.textosService.consultarTextos(changes.codigoRamo.currentValue);
            this.textos=[];
            textosResult.map(t=>{
                let temp: TextoVM=new TextoVM(t.codigo_texto, t.titulo_texto, t.textoD);
                this.textos.push(temp);
            });
            this.textoAclaratorio="";
            this.alternarLoader.emit();
        }
    }

    editarTextos(){
        let textosSeleccionados="";
        this.textos.forEach(t=>textosSeleccionados+=(t.seleccionado==true)?`${t.descripcion}\n\n`:"");
        this.textoAclaratorio=textosSeleccionados.substring(0, textosSeleccionados.length-2);
        this.textoAclaratorio = this.textoAclaratorio.replace(/[^a-zA-Z á-úÁ-ÚñÑ0-9\n]+/g, '');
    }

}